import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IAppVersionRequirementsUm } from '../app-version-requirements-um.model';
import { IOperatorAppVersionRequirementsVm } from '../operator-app-version-requirements-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorAppVersionRequirementsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorAppVersionRequirements`;
  }

  get(): Observable<IOperatorAppVersionRequirementsVm> {
    const headers = this.createHeaders();
    return this.http.get<IOperatorAppVersionRequirementsVm>(this.baseUrl, { headers });
  }

  put(appVersionRequirementsUm: IAppVersionRequirementsUm): Observable<IOperatorAppVersionRequirementsVm> {
    const headers = this.createHeaders();
    return this.http.put<IOperatorAppVersionRequirementsVm>(this.baseUrl, appVersionRequirementsUm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
